// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"GraphTypeButton_dropdown__3_hkd","toggle":"GraphTypeButton_toggle__3r6i5","option":"GraphTypeButton_option__11Vke"};